<template>
<v-dialog v-model="dialog" :max-width="options.width" :persistent="options.persistent" @keydown.esc="cancel()">
         <v-form v-model="valid" ref="form" lazy-validation>
      <v-card dense>
        <v-toolbar dense dark color="primary elevation-1">
          <v-toolbar-title>Send a notification</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="cancel" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="text-center text-h6 py-3"><v-icon>drive_eta</v-icon> {{ driver.name }}</v-card-text>

        <v-card-text class="">

            <v-layout wrap>
              <v-flex xs12>
                <v-textarea dense
                  rows="3"
                  v-model="form.msg"
                  label="Message"
                  :rules="itemRules"
                  required
                  prepend-icon="chat"
                  multi-line
                ></v-textarea>
              </v-flex>
            </v-layout>

        </v-card-text>
          <v-card-actions>
            <v-btn block
            dark
            color="primary" @click.native="save">Send</v-btn>
          </v-card-actions>
      </v-card>
      </v-form>
  </v-dialog>
</template>

<script>
import FormMixin from '@/mixins/formvalid';
export default {
  mixins: [FormMixin],
  props: {
    selectedCallback: Function
  },
  data () {
    return {
      id: null,
      dialog: false,
      resolve: null,
      reject: null,
      options: {
        persistent: false,
        color: 'primary',
        width: 350
      },
      valid: false,
      form: {
        title: 'Help4you',
        msg: ''
      },
      driver: {}
    };
  },
  methods: {
    cancel () {
      this.resolve(false);
      this.dialog = false;
    },
    save () {
      if (this.$refs.form.validate()) {
        this.resolve(this.form);
        this.dialog = false;
      }
    },
    open (item, options) {
      console.log('notify open: ', item);
      this.dialog = true;
      this.driver = item;
      this.options = Object.assign(this.options, options);
      this.form.driverId = item.driverId;
      this.form.msg = item.msg;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    }
  },
  created () {
    // this.getDrivers();
  }
};
</script>

<style scoped>

</style>
